import BoardSpecs from "../../../../src/components/post-components/BoardSpecs";
import CaptionedImage from "../../../../src/components/post-components/CaptionedImage";
import H2 from "../../../../src/components/post-components/H2";
import * as React from 'react';
export default {
  BoardSpecs,
  CaptionedImage,
  H2,
  React
};